import { useState } from 'react';
import { compareGroups } from '@/mocks/homeContent';
import SectionHead from './SectionHead';

export default function Compare() {
  const [active, setActive] = useState(0);
  const group = compareGroups[active];
  const lastRow = group.rows[group.rows.length - 1];

  return (
    <section id="compare" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <SectionHead
          eyebrow="同组对标·放一起比"
          title="搭讪博主风格横向对比"
          sub="定位相似的博主放到同一张表里比，差距一眼可见。左右代表同一赛道的不同风格选择。"
        />

        <div className="mb-6 flex flex-wrap justify-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          {compareGroups.map((g, idx) => (
            <button
              key={g.title}
              type="button"
              onClick={() => setActive(idx)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition ${
                active === idx ? 'bg-background-950 text-background-50' : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              {g.title}
            </button>
          ))}
        </div>

        <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-soft">
          <div className="grid grid-cols-[1fr_1.4fr_1.4fr] items-center gap-2 bg-background-950 px-4 py-4 text-background-50 sm:px-6">
            <span className="text-xs font-medium text-background-100/80 sm:text-sm">对比项</span>
            <div className="flex flex-col gap-0.5">
              <span className="font-heading text-sm font-bold sm:text-lg">{group.left.name}</span>
              <span className="hidden text-xs text-background-100/80 sm:block">{group.left.platform} · {group.left.style}</span>
            </div>
            <div className="flex flex-col items-end gap-0.5 text-right">
              <span className="font-heading text-sm font-bold sm:text-lg">{group.right.name}</span>
              <span className="hidden text-xs text-background-100/80 sm:block">{group.right.platform} · {group.right.style}</span>
            </div>
          </div>

          <div className="divide-y divide-background-100">
            {group.rows.slice(0, -1).map((row) => (
              <div key={row.label} className="grid grid-cols-[1fr_1.4fr_1.4fr] items-center gap-2 px-4 py-3 sm:px-6">
                <span className="text-xs font-bold text-foreground-500 sm:text-sm">{row.label}</span>
                <span className="text-sm leading-6 text-foreground-800 sm:text-base">{row.left}</span>
                <span className="text-right text-sm leading-6 text-foreground-800 sm:text-base">{row.right}</span>
              </div>
            ))}
          </div>

          <div className="grid grid-cols-[1fr_1.4fr_1.4fr] items-center gap-2 border-t-2 border-dashed border-primary-200 bg-primary-50/60 px-4 py-3.5 sm:px-6">
            <span className="text-xs font-bold text-primary-700 sm:text-sm">综合评分</span>
            <span className="font-heading text-xl font-black text-primary-600 sm:text-2xl">{lastRow.left}</span>
            <span className="text-right font-heading text-xl font-black text-accent-600 sm:text-2xl">{lastRow.right}</span>
          </div>

          <p className="border-t border-background-100 bg-background-50 px-4 py-3 text-xs text-foreground-500 sm:px-6">
            <i className="ri-information-line mr-1" aria-hidden="true"></i>
            对比基于近 30 天公开内容的编辑部独立观测，仅反映本期表现，供选择参考。
          </p>
        </div>
      </div>
    </section>
  );
}